import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import React, { lazy, Suspense, useEffect } from 'react'
import PropTypes from 'prop-types'
import 'react-dates/initialize'
// For React-Redux-Toastr - had to include a css file via CDN as a link tag
// Global CSS Libraries
import 'semantic-ui-css/semantic.min.css'
import 'react-dates/lib/css/_datepicker.css'
import ContactModal from './common/PeopleFormModal'
import ConfirmationModal from './common/confirmationModal'
import './index.css'
import fetchUserData from 'redux/actions/fetchCurrentUser' // eslint-disable-line
import { initializeIcons } from '@fluentui/react'
import { Helmet } from 'react-helmet'

import setLoader from 'redux/actions/setLoader' // eslint-disable-line
import { initializeScripts, SCRIPTS as TRACKER_SCRIPTS } from '../tracking/trackingScripts' // eslint-disable-line
import LoadingGif from './common/LoadingGif'

const AuthHighComponent = lazy(() => import(/* webpackChunkName: "AuthHighComponent" */ './Auth'))
const Onboarding = lazy(() => import(/* webpackChunkName: "Onboarding" */ './Onboarding'))
const PasswordReset = lazy(() => import(/* webpackChunkName: "PasswordReset" */ './PasswordReset'))

// initialize fabric icons
initializeIcons()
const isProduction = process.env.NODE_ENV !== 'development'

initializeScripts({
  isProduction
})

function DocumentHead({ accountName }) {
  return (
    <Helmet>
      <title>
        ResiDesk
        {accountName ? ` (${accountName})` : ''}
        {isProduction ? '' : ` (${process.env.NODE_ENV})`}
      </title>
      {isProduction
        ? Object.values(TRACKER_SCRIPTS).map((scr, idx) => (
            <script key={idx} type="text/javascript">
              {scr}
            </script>
          ))
        : null}
    </Helmet>
  )
}

const App = (props) => {
  const {
    auth,
    contactModalVisible,
    confirmationModalVisible,
    history,
    location,
    fetchUserData: fetchUser,
  } = props

  useEffect(() => {
    fetchUser(history)
  }, [fetchUser, history])

  useEffect(() => {
    const routerFunc = newUrl => history.push(newUrl);
    window?.CommandBar?.addRouter?.(routerFunc);
  }, [history])

  const loggedIn = auth.email

  // Handle password reset route at root level
  if (location.pathname === '/reset-password') {
    return (
      <div className="global-container">
        <DocumentHead />
        <Suspense fallback={<LoadingGif/>}>
          <PasswordReset />
        </Suspense>
      </div>
    )
  }

  return (
    <div className="global-container">
      <DocumentHead accountName={auth?.account?.name} />
      <Suspense fallback={<LoadingGif/>}>
        {loggedIn ? <AuthHighComponent /> : <Onboarding />}
        {contactModalVisible ? <ContactModal /> : null}
        {confirmationModalVisible ? <ConfirmationModal /> : null}
      </Suspense>
    </div>
  )
}

App.propTypes = {
  auth: PropTypes.object.isRequired,
  fetchUserData: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  contactModalVisible: PropTypes.bool.isRequired,
  confirmationModalVisible: PropTypes.bool.isRequired,
  setLoader: PropTypes.func.isRequired,
  loader: PropTypes.object.isRequired,
}

const mapStateToProps = ({
  auth,
  contactModal: { contactModalVisible },
  confirmationModal: { confirmationModalVisible },
  loader,
}) => ({
  auth,
  contactModalVisible,
  confirmationModalVisible,
  loader,
})

const mapDispatchToProps = {
  fetchUserData,
  setLoader,
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(App),
)
